import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { COOKIE_NAMES } from '@finder/shared/constants/cookies.constants';
import { FormsModule } from '@angular/forms';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';

@Component({
    selector: 'finder-language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule
    ]
})
export class LanguageSelectorComponent implements OnInit {
    locations: Array<any> = [];
    selectedLanguage: any = '';

    private cookiePath = '/';

    constructor(
        private cookieService: CookieService,
        private winRef: WindowRef,
    ) {}

    ngOnInit() {
        this.setupLanguageSelector();
    }

    setupLanguageSelector() {
        // Get the value from the cookie
        try {
            const cookieValue = JSON.parse(this.cookieService.get(COOKIE_NAMES.LANGUAGE_SELECTION_AKA));
            this.selectedLanguage = cookieValue?.preferredLanguage; // get(cookieValue, 'preferredLanguage');
        } catch(err) {}

        const langWdw = [
            {
                'name': 'English',
                'value': 'en_US'
            }, {
                'name': 'Español',
                'value': 'es-us'
            }, {
                'name': 'Canada (English)',
                'value': 'en_CA'
            }, {
                'name': 'Canada (French)',
                'value': 'fr-ca'
            }, {
                'name': 'Argentia (Español)',
                'value': 'es-ar'
            }, {
                'name': 'Mexico (Español)',
                'value': 'es-mx'
            }, {
                'name': 'Peru (Español)',
                'value': 'es-pe'
            }, {
                'name': 'Colombia (Español)',
                'value': 'es-co'
            }, {
                'name': 'Chile (Español)',
                'value': 'es-cl'
            }, {
                'name': 'Brasil (Español)',
                'value': 'pt-br'
            }
        ];

        const langWdwEu = [{
            'name': 'English (UK)',
            'value': 'en_GB'
        },{
            'name': 'English (EU)',
            'value': 'en_eu'
        }];

        const langDlr = [
            {
                'name': 'English',
                'value': 'en_US'
            }, {
                'name': 'Estados Unidos (Español)',
                'value': 'es-us'
            }, {
                'name': 'Canada (English)',
                'value': 'en-ca'
            }
        ];

        const langHkdl = [
            {
                'name': 'English',
                'value': 'en_US'
            }, {
                'name': 'Hong Kong (Chinese)',
                'value': 'zh-hk'
            }, {
                'name': 'Chinese (Peoples Republic of China)',
                'value': 'zh-cn'
            }, {
                'name': 'Japanese',
                'value': 'ja'
            }, {
                'name': 'Korean',
                'value': 'ko'
            }, {
                'name': 'Thai',
                'value': 'th'
            }, {
                'name': 'Bahasa Indonesia',
                'value': 'id'
            }, {
                'name': 'Bahasa Malaysia',
                'value': 'ms'
            }
        ];

        this.locations = [
            {
                'name': 'Disneyworld',
                'values': langWdw
            }, {
                'name': 'Disneyland',
                'values': langDlr
            }, {
                'name': 'Hong Kong Disneyland',
                'values': langHkdl
            }, {
                'name': 'Disneyworld (eu/uk)',
                'values': langWdwEu
            }
        ];
    }

    saveLanguage() {
        // If no language is selected, do nothing
        if (!this.selectedLanguage) {
            return;
        }

        const cookieValue = {
            'preferredLanguage': this.selectedLanguage,
            'version': '1',
            'precedence': 0,
            'language': this.selectedLanguage,
            'akamai': 'true'
        };
        this.cookieService.set(COOKIE_NAMES.LANGUAGE_SELECTION_AKA, JSON.stringify(cookieValue), null, this.cookiePath);
        this.winRef.nativeWindow.location.reload();
    }
}
